import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

const Reviews = () => {
  const { reviews } = useContent();
  return (
    <div data-testid="reviews-page" className="pt-36 md:pt-48 pb-28">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-[0.65rem] uppercase tracking-[0.4em] text-gold mb-6">Kind Words</p>
          <h1 className="font-serif text-5xl sm:text-6xl md:text-8xl font-light tracking-tight leading-none max-w-4xl">
            Trusted with life's <span className="italic text-beige">rarest</span> moments.
          </h1>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-2 gap-6 md:gap-8">
          {reviews.map((r, i) => (
            <Reveal key={i} delay={(i % 2) * 0.1}>
              <div
                data-testid={`review-card-${i}`}
                className={`h-full border border-white/10 p-10 md:p-12 flex flex-col justify-between transition-colors duration-500 hover:border-gold/40 ${i % 3 === 0 ? "bg-ink2" : "bg-transparent"}`}
              >
                <div>
                  <span className="font-serif text-5xl text-gold/40 leading-none block mb-4">"</span>
                  <blockquote className="font-serif text-2xl md:text-3xl font-light leading-snug tracking-tight">
                    {r.quote}
                  </blockquote>
                </div>
                <div className="mt-10 pt-6 border-t border-white/10">
                  <p className="font-serif text-xl">{r.name}</p>
                  <p className="text-[0.65rem] uppercase tracking-[0.3em] text-muted2 mt-1">{r.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
